import React from "react";
import Layout from "../hoc/Layout";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ConditionLayout from "../layouts/ConditionLayout";

const ConditionsGenerale = () => {
  return (
    <Layout title="Conditions Générales d'Utilisation">
      <Header />
      {/* for terms and Conditions */}
      <ConditionLayout />
      <Footer />
    </Layout>
  );
};

export default ConditionsGenerale;
